// extracted by mini-css-extract-plugin
export var base = "_4e-0";
export var updateBanner = "_4e-1";